<template>
    <div class="c-personalDataForm">
        <div class="c-personalDataForm__fields">
            <div class="c-personalDataForm__input" v-bind:class="checkField('first_name')">
                <label>
                    <input type="text" placeholder="Imię" v-model="formData.first_name">
                </label>
            </div>
            <div class="c-personalDataForm__input" v-bind:class="checkField('last_name')">
                <label>
                    <input type="text" placeholder="Nazwisko" v-model="formData.last_name">
                </label>
            </div>
        </div>
        <div class="c-personalDataForm__fields" v-bind:class="checkField('email')" >
            <div class="c-personalDataForm__input">
                <label>
                    <input type="email" placeholder="Adres e-mail" v-model="formData.email">
                </label>
            </div>
            <div class="c-personalDataForm__input" v-bind:class="checkField('phone_number')">
                <label>
                    <input type="tel" placeholder="Numer telefonu" v-model="formData.phone_number">
                </label>
            </div>
        </div>
        <div class="c-personalDataForm__accept" v-bind:class="checkField('accept1')">
            <input type="checkbox" id="consent" v-model="formData.accept1" true-value="1" false-value="0">
            <div>
                <label for="consent">
                    <p>
                        Pozostawienie przez Pana/Panią danych i wysłanie formularza oznacza zgodę dla Auto Group Polska Sp. z o.o. z siedzibą we Wrocławiu na skontaktowanie się - w celu przedstawienia informacji na temat zakupu samochodu, usług serwisowych, możliwych sposobów finansowania, ubezpieczenia lub zaproponowania i umówienia jazdy testowej – z użyciem numeru telefonu lub adresu e-mail. Podanie danych jest dobrowolne, ale konieczne do kontaktu w celu obsługi zapytania i przygotowania oferty.
                        W każdej chwili możesz cofnąć udzieloną zgodę wysyłając e-mail na adres: <a href="mailto:iod@autogrouppolska.pl">iod@autogrouppolska.pl</a>
                    </p>
                </label>
                <p v-if="consentToggle">
                    Po zweryfikowaniu Pana/Pani danych i potwierdzeniu zainteresowania powyższymi informacjami - w celu przygotowania konkretnej oferty - Pana/Pani dane przekażemy do Volkswagen Group Polska Sp. z o.o. z siedzibą w Poznaniu (61-037), ul. Krańcowa 44 wpisanej do Rejestru Przedsiębiorców prowadzonego przez Sąd Rejonowy w Poznaniu – Nowe Miasto i Wilda, pod numerem KRS 0000327143, NIP 782-24-63-563, REGON 301062169 (VGP).
                </p>
                <p v-if="consentToggle">
                    Szczegółowe informacje na temat przetwarzania Twoich danych osobowych znajdziesz pod linkiem: <a href="https://centrumwroclaw.pl/rodo/" target="_blank">https://centrumwroclaw.pl/rodo/</a>
                </p>
                <p class="c-personalDataForm__acceptShow">
                    <strong v-on:click="consentToggle = !consentToggle">
                        {{consentToggle?'Zobacz mniej':'Zobacz więcej'}}
                    </strong>
                </p>
            </div>
        </div>
        <div class="c-personalDataForm__fields" v-if="showSubmit">
            <div class="c-personalDataForm__input">
                <button  class="c-personalDataForm__button" v-bind:class="[{'c-personalDataForm__button--disabled':errors.length != 0}]" v-on:click="$emit('clickSubmit',true)">Wyślij</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
   data(){
       return {
           consentToggle:false,
           formData:{
               first_name:'',
               last_name:'',
               phone_number:'',
               email:'',
               accept1:''
           },
           errors:[],
           required:['first_name','last_name','accept1'],
           requiredGroup:['phone_number','email']
       }
    },
    props:['showSubmit'],
    methods:{
        validate(){
            this.errors = [];
            this.errors = [
                ...this.required.filter( e => this.formData[e] == ''),
                ...this.requiredGroup.filter( e => this.formData[e]  == '' ).length > 1 ? this.requiredGroup:[]
            ];
            this.$emit('isValid',this.errors.length == 0? true : false);
        },
        checkField(name){
            let r = '';
            if(this.errors.length > 0 && this.errors.includes(name)) {
                r = 'c-personalDataForm--error';
            }else if(this.errors.length > 0 && !this.errors.includes(name)){
                r = 'c-personalDataForm--correct';
            };
            return r;
        }
    },
    watch:{
        formData:{
            handler() {
                this.validate();
                this.$emit('changeForm',this.formData)
            },
            deep:true
        }
    }
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-personalDataForm{
        &__fields{
            max-width: 630px;
            @media (min-width: 780px) {
                display: flex;
                justify-content: space-between;
            }
        }
        &__input{
            width: 100%;
            padding: 1rem .5rem;
            input[type=text],input[type=tel],input[type=email]{
                font-family: 'Montserrat';
                width: 100%;
                padding: .75rem 1rem;
                border: 1px solid $gray;
                font-size: 1rem;
                border-radius: .25rem;
                font-size: .9rem;
                color: $black;
                outline: 0;
                &:focus,&:focus-visible{
                    border: 1px solid $darkLazuri;
                }
                &::placeholder{
                    color: $black;
                }
            }
        }
        &--error{
            input[type=text],input[type=tel],input[type=email],input[type=checkbox]{
                border: 1px solid $error;
            }
        }
        &--correct{
            input[type=text],input[type=tel],input[type=email],input[type=checkbox]{
                border: 1px solid $success;
            }
        }
        &__accept{
            font-size: .7rem;
            color: $darkGray;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            input[type=checkbox]{
                margin-top: 1rem;
                margin-right: 1rem;
            }
            a{
                text-decoration: none;
                color: $darkGray;
            }
        }
        &__button{
            border-radius: .5rem;
            border: 0;
            padding: .75rem 3rem;
            background: $darkLazuri;
            color: #fff;
            font-size: 1.2rem;
            cursor: pointer;
            position: relative;
            &::after{
                content: ' ';
                display: block;
                position: absolute;
                top: 0rem;
                left: 0rem;
                right: 0rem;
                bottom: 0rem;
                border: 1px dashed $darkLazuri;
                border-radius: .5rem;
                transition: all .5s;
                opacity: 0;
            }
            &:hover{
                &::after{
                    top: -.5rem;
                    left: -.5rem;
                    right: -.5rem;
                    bottom: -.5rem;
                    opacity: 1;
                }
            }
            &--disabled{
                opacity: .5;
                cursor: no-drop;
            }
        }
        &__acceptShow{
            cursor: pointer;
            &:hover{
                color: $darkLazuri;
            }
        }
    }
</style>
